import _ from 'lodash';
import moment from 'moment';
import { currentCompanyId } from 'utils/company';
import { unmarshallAttributes } from 'utils/filter';
import { Company as CompanyModel } from './companies';
import { arrayToObject, objectToArray, sanitize } from '../filter';

const getFromIncluded = (included, type, id) => included.find((item) => (
  item.type === type && item.id === id
));

export const Report = ({ report, included }) => {
  const company = getFromIncluded(included, 'companies', _.get(report, 'relationships.company.data.id'));
  const category = getFromIncluded(included, 'categories', _.get(report, 'relationships.category.data.id'));

  const response = {
    id: report.id,
    name: report.attributes.name,
    baseFilters: objectToArray(report.attributes.base_filters),
    blacklisted_attributes: report.attributes.blacklisted_attributes || [],
    category: _.get(category, 'attributes.name'),
    categoryId: _.get(category, 'id'),
    campaignId: report.attributes.campaign_id,
    linked: !_.isEmpty(report.attributes.campaign_id),
    archived: report.attributes.archived,
    hidden: report.attributes.hidden,
    accessGrantedTo: report.attributes.access_granted_to,
    company: CompanyModel(company),
    createdAt: moment(report.attributes.created_at),
    feedbacks: {
      count: _.get(report, 'meta.feedbacks_count'),
    },
  };

  return response;
};

export const CreateReport = (data) => {
  const attributes = _.pick(data, ['name']);
  attributes.base_filters = arrayToObject(sanitize(data.baseFilters));

  const spotAttributes = _.get(attributes, 'base_filters.spot.attributes');
  if (spotAttributes) {
    _.set(attributes, 'base_filters.spot', unmarshallAttributes(spotAttributes));
  }

  const createWidgets = _.get(data, 'createWidgets');
  if (createWidgets) {
    attributes.create_widgets = true;
  }

  const blacklistedAttributes = _.get(data, 'blacklisted_attributes');
  if (blacklistedAttributes) {
    attributes.blacklisted_attributes = blacklistedAttributes;
  }

  const response = {
    data: {
      type: 'reports',
      attributes,
    },
  };

  const categoryId = _.get(data, 'categoryId');

  const relationships = {
    company: {
      data: {
        type: 'companies',
        id: currentCompanyId(),
      },
    },
  };

  if (!_.isEmpty(categoryId)) {
    relationships.category = {
      data: {
        type: 'categories',
        id: categoryId,
      },
    };
  }

  _.merge(response, { data: { relationships } });

  return response;
};

export const UpdateReport = (reportId, data) => (
  {
    data: {
      type: 'reports',
      id: reportId,
      attributes: {
        name: _.get(data, 'name'),
        category_id: _.get(data, 'categoryId'),
        base_filters: arrayToObject(sanitize(data.baseFilters)),
        blacklisted_attributes: _.get(data, 'blacklisted_attributes'),
      },
    },
  }
);

export const ArchiveReport = (reportId, data) => (
  {
    data: {
      type: 'reports',
      id: reportId,
      attributes: {
        archived: _.get(data, 'archived'),
      },
    },
  }
);

export const HideReport = (reportId, data) => (
  {
    data: {
      type: 'reports',
      id: reportId,
      attributes: {
        hidden: _.get(data, 'hidden'),
      },
    },
  }
);

export const UpdateAccess = (reportIds, actions) => (
  {
    report_ids: reportIds,
    actions: Object.keys(actions).map((action) => ({
      action,
      users: actions[action],
    })),
  }
);

export const ReportsList = (data, included) => data.map((report) => Report({ report, included }));
